export enum PublishJobType {
    SKYSPARK_CREATE_PROJECT = 'SkySparkCreateProject',
    SKYSPARK_ENABLE_EXTENSIONS = 'SkySparkEnableExtensions',
    SKYSPARK_ENABLE_RULES = 'SkySparkEnableRules',
    AZURE_ELASTIC_POOL_AND_DB_CREATION = 'AzureElasticPoolAndDbCreation',
    AZURE_DB_TABLES_CREATION = 'AzureDbTablesCreation',
    DASHBOARD_CONFIGURATION = 'DashboardConfiguration',
    SKYSPARK_IMPORT_MODEL = 'SkySparkImportModel',
    CREATE_HISTORY_IMPORT_DB_AND_SQL_CONNECTOR = 'CreateHistoryImportDbAndSqlConnector',
    IMPORT_HISTORY_FROM_CSV_TO_SQL = 'ImportHistoryFromCsvToSql',
    SKYSPARK_RETRIEVAL = 'SkySparkRetrieval'
  }
